import React from 'react';
import {TFunction} from 'react-i18next';
import {useUserContext} from 'authentication/UserContext';
import {getParagraphListBaseColumns} from '../ParagraphListBaseColumns';
import {EntityListColumn} from 'components';

const hiddenForAvk = new Set<string>([
	'p-vehicle-category',
	'p-tags',
	'p-drive-variants',
	'p-dateNewTypes',
	'p-dateNewRegistration',
	'p-phaseIn',
	'p-phaseOut',
	'p-requirements',
	'p-changeInfoType',
]);

const hiddenForVex = new Set<string>([
	'p-categories',
	'p-vehicle-category',
	'p-tags',
	'p-drive-variants',
	'p-dateNewTypes',
	'p-dateNewRegistration',
	'p-phaseIn',
	'p-phaseOut',
]);

const hiddenForVko = new Set<string>(['p-requirements', 'p-tags']);

const hiddenForReader = hiddenForVex;

const hiddenForBedarfskoordinator = new Set<string>([
	'p-categories',
	'p-vehicle-category',
	'p-drive-variants',
	'p-dateNewTypes',
	'p-dateNewRegistration',
	'p-phaseIn',
	'p-phaseOut',
]);

export type UseParagraphListColumnsParams = {
	t: TFunction;
	tt: TFunction;
	tEnum: TFunction;
	filterable?: boolean;
	lazyLoadedTooltips?: boolean;
	shouldShowFaq?: boolean;
	myKeywords?: any;
	isReqifz?: boolean;
};

export const useParagraphListColumns = ({
	t,
	tt,
	tEnum,
	filterable = true,
	lazyLoadedTooltips = false,
	shouldShowFaq,
	myKeywords,
	isReqifz = false,
}: UseParagraphListColumnsParams): EntityListColumn[] => {
	const {isAvk, isVex, isVko, isReader, isBedarfskoordinator} =
		useUserContext();

	const baseColumns = React.useMemo(
		() =>
			getParagraphListBaseColumns(
				t,
				tt,
				tEnum,
				filterable,
				lazyLoadedTooltips,
				shouldShowFaq,
				myKeywords,
				isReqifz,
			),
		[
			t,
			tt,
			tEnum,
			filterable,
			lazyLoadedTooltips,
			shouldShowFaq,
			myKeywords,
			isReqifz,
		],
	);

	return React.useMemo(() => {
		const roleHidden = (() => {
			if (isAvk) return hiddenForAvk;
			if (isVex) return hiddenForVex;
			if (isVko) return hiddenForVko;
			if (isReader) return hiddenForReader;
			if (isBedarfskoordinator) return hiddenForBedarfskoordinator;
			return null;
		})();

		if (!roleHidden) return baseColumns;
		return baseColumns.filter(col => !roleHidden.has(col.key ?? ''));
	}, [baseColumns, isAvk, isVex, isVko, isReader, isBedarfskoordinator]);
};
